import Swiper, { Navigation, Pagination } from "swiper";
import { Fancybox, Panzoom } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;
window.Swiper = Swiper;

// ========================
// == Trigger Tabs By Hash
var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function (triggerEl) {
    var tabTrigger = new bootstrap.Tab(triggerEl);
    var hash = "#" + triggerEl.href.split("#")[1];
    var tabBtn = document.querySelector(hash + "-tab");

    triggerEl.addEventListener("click", function (event) {
        event.preventDefault();
        tabBtn.click();
    });
});
// END Trigger Tabs By Hash
// ========================

// ========================
// == Add class to main navbar on scroll

const navbar = document.querySelector("#site-nav");

const winWidth = window.innerWidth;
if (winWidth > 767) {
    window.addEventListener("scroll", function () {
        let scroll = window.scrollY;
        if (scroll > 81) {
            navbar.classList.add("is-stuck");
        } else {
            navbar.classList.remove("is-stuck");
        }
    });
}

// END scrolled
// ========================

// ========================
// == Panzoom =============

const panzoom = document.querySelector(".panzoom");
const panzoom_reset = document.querySelector(".panzoom-reset");
const panZoomImg = document.querySelector(".panzoom__content");
const fpImgLink = document.querySelectorAll("[data-imgurl]");

if (panzoom) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale: 0.5,
        maxScale: 3,
    });
    panzoom_reset.addEventListener("click", function (event) {
        myPanzoom.zoomTo(1);
    });
}

for (const link of fpImgLink) {
    link.addEventListener("click", function () {
        fpImgLink.forEach((e) => {
            e.classList.remove("active-bg");
        });
        link.classList.add("active-bg");
        var imgUrl = link.dataset.imgurl;
        panZoomImg.src = imgUrl;
    });
}

// END Panzoom ============
// ========================

/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false;

/** Abstracted event action handler
 * @param {import("@fancyapps/ui").Fancybox} fancybox
 */
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
};

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", {
    on: {
        initCarousel: (fancybox) => {
            if (!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true;

                // Do Fancybox event
                doFancyboxOiEvent(fancybox);

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false;
                }, 1000);
            }
        },
        done: (fancybox, slide) => {
            if (!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox);
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false;
        },
    },
});

/* END FANCYBOX */

// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener(
    "load",
    function () {
        AOS.init();
        oi.utils.wrap_oi_aspect();
    },
    false,
);

// addtional scripts

document.querySelectorAll(".nav-btn").forEach((button) => {
    button.addEventListener("click", function () {
        this.classList.toggle("open");
        document.querySelector(".mobile-navigation").classList.toggle("open");
    });
});

document.querySelectorAll(".connect-btn a").forEach((link) => {
    link.addEventListener("click", function () {
        document.querySelector(".mobile-navigation").classList.remove("open");
    });
});

function addScrollOnSuccess(formType, selector, offset = 200, delay = 500) {
    window.addEventListener(`oi.loaded.form.${formType}`, function () {
        const form = oi.loaded.form[formType];
        if (form) {
            form.addSuccessAction = () => {
                const targetElement = document.querySelector(selector);
                if (targetElement) {
                    const elementTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
                    setTimeout(() => {
                        window.scrollTo({
                            top: elementTop - offset,
                            behavior: "smooth",
                        });
                    }, delay);
                }
            };
        }
    });
}

// Attach to both forms
["contactform", "signupform"].forEach((formType) => {
    addScrollOnSuccess(formType, ".contact-form-container");
});

window.addEventListener("oi.loaded.form.contactform", function () {
    oi.loaded.form.contactform.addSuccessAction = function (response) {
        if (response.data.data.redirect_url) {
            window.location.href = response.data.data.redirect_url;
        }
    };
});

window.addEventListener("oi.loaded.form.signupform", function () {
    oi.loaded.form.signupform.addSuccessAction = function (response) {
        if (response.data.data.redirect_url) {
            window.location.href = response.data.data.redirect_url;
        }
    };
});
